export const getMessage = (key) =>
  window?.ikea?.purchaseAgent?.text ? window.ikea.purchaseAgent.text[key] : undefined